/** 深蓝主题默认主色（CSS 变量不可用时的回退） */
export const EL_COLOR_PRIMARY_FALLBACK = '#0057B4'

/** 运行时读取 Element 主色（随 dashboard 双主题 CSS 变量变化） */
export function getElColorPrimary (): string {
  if (typeof document === 'undefined') return EL_COLOR_PRIMARY_FALLBACK
  const v = getComputedStyle(document.documentElement)
    .getPropertyValue('--el-color-primary')
    .trim()
  return v || EL_COLOR_PRIMARY_FALLBACK
}

function parseColorToRgb (color: string): [number, number, number] | null {
  const c = color.trim()
  if (c.startsWith('#')) {
    const h = c.slice(1)
    if (h.length === 3) {
      return [
        parseInt(h[0] + h[0], 16),
        parseInt(h[1] + h[1], 16),
        parseInt(h[2] + h[2], 16),
      ]
    }
    if (h.length >= 6) {
      return [
        parseInt(h.slice(0, 2), 16),
        parseInt(h.slice(2, 4), 16),
        parseInt(h.slice(4, 6), 16),
      ]
    }
    return null
  }
  const m = c.match(/rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)/)
  if (m) return [Number(m[1]), Number(m[2]), Number(m[3])]
  return null
}

/** ECharts / 内联样式等不支持 CSS 变量时的主色半透明 */
export function getElColorPrimaryRgba (alpha: number): string {
  const rgb = parseColorToRgb(getElColorPrimary())
  if (!rgb) {
    const fb = parseColorToRgb(EL_COLOR_PRIMARY_FALLBACK)!
    return `rgba(${fb[0]}, ${fb[1]}, ${fb[2]}, ${alpha})`
  }
  return `rgba(${rgb[0]}, ${rgb[1]}, ${rgb[2]}, ${alpha})`
}
